import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Storage } from "../../storage";
import { deleteNote } from "../../apis/venue-notes";

export function usePostNoteDelete() {
  const queryClient = useQueryClient();

  const { data, error, mutate, status } = useMutation({
    mutationFn: ({ noteId }: { noteId: string }) => {
      return deleteNote({
        noteId,
        token: Storage.getCurrentUserToken() || "",
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["loadVenueDetailsBySlug"],
        exact: false,
      });
    },
  });
  return {
    data,
    error,
    mutate,
    status,
  };
}
